import { Link, useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

const SUPPRESS_PATHS = ['/help', '/auth', '/reset-password'];

export default function FloatingHelpButton() {
  const { pathname } = useLocation();
  if (SUPPRESS_PATHS.some((p) => pathname.startsWith(p))) return null;

  return (
    <Link
      to="/help"
      aria-label="Help Centre"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full border border-border bg-background/90 backdrop-blur-sm px-3.5 py-2 shadow-md text-sm font-medium text-muted-foreground hover:text-foreground hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
    >
      <HelpCircle className="h-4 w-4 shrink-0" />
      <span className="hidden sm:inline">Help</span>
    </Link>
  );
}
